export const CAPTION_STATES = {
  BREAKING: "breaking",
  REQUIRED: "required",
  OPTIONAL: "optional",
  EMPTY: "empty"
};
